import * as React from 'react';
import Table from '@mui/material/Table';
import TableBody from '@mui/material/TableBody';
import TableCell from '@mui/material/TableCell';
import TableContainer from '@mui/material/TableContainer';
import TableHead from '@mui/material/TableHead';
import TableRow from '@mui/material/TableRow';
import Paper from '@mui/material/Paper';
import ArrowBackIcon from '@mui/icons-material/ArrowBack';
import { useDispatch, useSelector } from 'react-redux';
import { TextField } from '@mui/material';
import { useNavigate } from 'react-router-dom';
import IndexedDBService, { VMixButtonApiSetting } from '../../Utils/DBConfig';
import { setVMixZoomButton } from '../../Slice/vMixZoomSlice';

const VMixZoomSetting = () => {
    const navigate = useNavigate();
    const dispatch = useDispatch();
    const VMixZoomButton = useSelector((state) => state.vMixZoomButton.VMixZoomButton);
    const [rows, setRows] = React.useState([]);

    React.useEffect(() => {
        if (VMixZoomButton.length > 0) {
            setRows(VMixZoomButton);
        }
    }, [VMixZoomButton]);

    const handleApiChange = (e, id) => {
        const { value } = e.target;
        setRows(prevRows => {
            const updatedRows = prevRows.map(row =>
                row.id === id ? { ...row, api: value } : row
            );
            return updatedRows;
        });
    };

    const handleApiNameChange = (e, id) => {
        const { value } = e.target;
        setRows(prevRows => {
            const updatedRows = prevRows.map(row =>
                row.id === id ? { ...row, name: value } : row
            );
            return updatedRows;
        });
    };

    const handleBackToHome = () => {
        rows.forEach((button) => {
            let obj = { ...button };
            IndexedDBService.updateItem(obj, VMixButtonApiSetting)
                .then(() => { })
                .catch(() => { })
                .finally(() => { });
        });
        dispatch(setVMixZoomButton(rows));
        navigate('/');
    };

    React.useEffect(() => {
        console.log('rows: ', rows);
    }, [rows]);

    return (
        <>
            <button className="absolute top-1 right-2 px-1 pb-1 text-xl bg-red-600 text-white rounded-full" onClick={handleBackToHome}><ArrowBackIcon /></button>
            <TableContainer component={Paper}>
                <Table sx={{ minWidth: 650 }} aria-label="simple table">
                    <TableHead>
                        <TableRow>
                            <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>Id</TableCell>
                            <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>Name</TableCell>
                            <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>Api</TableCell>
                        </TableRow>
                    </TableHead>
                    <TableBody>
                        {rows && rows.map((row) => (
                            <TableRow key={row.id}>
                                <TableCell align="center" scope="row" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                                    {row.id}
                                </TableCell>
                                <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <TextField
                                            key={`${row.id}`} // Unique key for each TextField
                                            className='w-full'
                                            value={row.name}
                                            onChange={(event) => handleApiNameChange(event, row.id)}
                                            size="small"
                                            variant="outlined"
                                            style={{ marginLeft: 8 }}
                                        />
                                    </div>
                                </TableCell>
                                <TableCell align="center" sx={{ border: '1px solid rgba(224, 224, 224, 1)' }}>
                                    <div style={{ display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
                                        <TextField
                                            key={`${row.id}`} // Unique key for each TextField
                                            className='w-full'
                                            value={row.api}
                                            onChange={(event) => handleApiChange(event, row.id)}
                                            size="small"
                                            variant="outlined"
                                            style={{ marginLeft: 8 }}
                                        />
                                    </div>
                                </TableCell>
                            </TableRow>
                        ))}
                    </TableBody>
                </Table>
            </TableContainer>
        </>
    );
};

export default VMixZoomSetting;
